<section class="flex h-full w-full flex-col overflow-hidden bg-white text-slate-900" role="dialog">
  <header class="flex shrink-0 items-center gap-3 border-b !border-slate-100 px-4 py-3">
    <div class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-orange-50 text-orange-600">
      <app-icon>warehouse</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 truncate text-base font-bold leading-6">{{ 'stock.funnel_settings.title' | translate }}</h2>
      <p class="m-0 text-xs text-slate-400">{{ 'stock.funnel_settings.subtitle' | translate }}</p>
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100"
      [attr.aria-label]="'close' | translate"
      (click)="close.emit()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  @if (loading) {
    <div class="flex flex-col gap-3 p-4">
      @for (row of [1, 2, 3]; track row) {
        <div class="h-20 animate-pulse rounded-lg bg-slate-100"></div>
      }
    </div>
  } @else if (loadFailed) {
    <div class="flex flex-1 flex-col items-center justify-center gap-3 p-5 text-center">
      <app-icon class="!text-[32px] text-slate-300">error_outline</app-icon>
      <p class="m-0 text-sm text-slate-600">{{ 'stock.load_failed' | translate }}</p>
      <app-button btnType="stroked" (onChangeClick)="load()">{{ 'stock.retry' | translate }}</app-button>
    </div>
  } @else {
    <div class="crm-scroll flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-4 py-4">
      <div class="flex flex-col gap-1.5">
        <app-select
          [formControl]="form.controls.reserve_column_ids"
          [type]="SelectType.Multiple"
          [options]="columns"
          optionLabel="name"
          optionValue="id"
          display="chip"
          [maxSelectedLabels]="20"
          [showClear]="true"
          [label]="'stock.funnel_settings.reserve_column' | translate"
          [placeholder]="'stock.funnel_settings.not_set' | translate"
        />
        <p class="m-0 text-xs leading-5 text-slate-500">{{ 'stock.funnel_settings.reserve_hint' | translate }}</p>
      </div>

      <div class="flex flex-col gap-1.5">
        <app-select
          [formControl]="form.controls.write_off_column_ids"
          [type]="SelectType.Multiple"
          [options]="columns"
          optionLabel="name"
          optionValue="id"
          display="chip"
          [maxSelectedLabels]="20"
          [showClear]="true"
          [label]="'stock.funnel_settings.write_off_column' | translate"
          [placeholder]="'stock.funnel_settings.not_set' | translate"
        />
        <p class="m-0 text-xs leading-5 text-slate-500">{{ 'stock.funnel_settings.write_off_hint' | translate }}</p>
      </div>

      <div class="flex flex-col gap-1.5">
        <app-select
          [formControl]="form.controls.default_warehouse_id"
          [options]="warehouses"
          optionLabel="name"
          optionValue="id"
          [showClear]="true"
          [filter]="true"
          [label]="'stock.funnel_settings.default_warehouse' | translate"
          [placeholder]="'stock.funnel_settings.not_set' | translate"
        />
        <p class="m-0 text-xs leading-5 text-slate-500">
          {{ 'stock.funnel_settings.default_warehouse_hint' | translate }}
        </p>
      </div>

      <div class="flex items-start gap-2 rounded-lg bg-slate-50 px-3 py-2 text-xs leading-5 text-slate-600">
        <app-icon class="!h-4 !w-4 shrink-0 !text-[16px] !leading-none text-slate-400">info</app-icon>
        <span>{{ 'stock.funnel_settings.note' | translate }}</span>
      </div>

      @if (overlap) {
        <div class="rounded-lg border !border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600">
          {{ 'stock.errors.FUNNEL_WAREHOUSE_SETTINGS_INVALID.same_column' | translate }}
        </div>
      }
    </div>
  }

  <footer class="flex shrink-0 gap-2 border-t !border-slate-100 px-4 py-3">
    <app-button
      btnType="stroked"
      class="flex-1"
      [customClass]="'w-full !h-10 !rounded-lg'"
      (onChangeClick)="close.emit()"
    >
      {{ 'cancel' | translate }}
    </app-button>
    <app-button
      class="flex-1"
      [customClass]="'w-full !h-10 !rounded-lg'"
      [disabled]="saving || loading || loadFailed || overlap"
      (onChangeClick)="save()"
    >
      {{ (saving ? 'saving' : 'save') | translate }}
    </app-button>
  </footer>
</section>
